import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export const postProdutosLeadMultiple = async (params: {
  idsLeadCorretor: string[];
  idsEmpreendimentos: string[];
}) => {
  const url = `${leadsWebEnviroment}/commom/leads/produtos-lead-massa/v1`;
  const response = await instance.post(url, params);
  return response?.data;
};
